import * as React from 'react';
import Features from './Features.tsx';
import FAQ from './FAQ.tsx';
import Highlights from './Highlights.tsx';
import Pricing from './Pricing.tsx';

import Divider from '@mui/material/Divider';
import {useLocation} from "react-router-dom";

export default function Home() {
    const {state} = useLocation();
    React.useEffect(()=>{
        if (state?.selectedHomeSection) {
            const selectedHomeSection = document.getElementById(state?.selectedHomeSection);
            if (selectedHomeSection) {
              selectedHomeSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
    
    }, [state]);
    return (
        <div>
            <Features />
                <Divider />
            <Highlights />
                <Divider />
            <Pricing />
                <Divider />
            <FAQ />
        </div>
    )
}